import React from 'react'

import logo from '../../assets/img/sobremesas.png'

const SobremesasImage = () => (
  <div className='default-image'>
    <img src={logo}  alt='Sobremesas' style={{ width: '100%' }} />
  </div>
)

export default SobremesasImage